import * as actionTypes from 'modules/Taps/redux/okveds/actionTypes';

export const getOkveds = (payload) => ({ type: actionTypes.GET_OKVEDS, payload });
export const getOkvedsSuccess = (payload) => ({ type: actionTypes.GET_OKVEDS_SUCCESS, payload });
export const getOkvedsFailure = (payload) => ({ type: actionTypes.GET_OKVEDS_FAILURE, payload });

export const getPopularOkveds = (payload) => ({ type: actionTypes.GET_POPULAR_OKVEDS, payload });
export const getPopularOkvedsSuccess = (payload) => ({
  type: actionTypes.GET_POPULAR_OKVEDS_SUCCESS,
  payload,
});
export const getPopularOkvedsFailure = (payload) => ({
  type: actionTypes.GET_POPULAR_OKVEDS_FAILURE,
  payload,
});
